export enum IconSize {
    XXSMALL = 'XXSMALL',
    XSMALL = 'XSMALL',
    MSMALL = 'MSMALL',
    SMALL = 'SMALL',
    REGULAR = 'REGULAR',
    XREGULAR = 'XREGULAR',
    MEDIUM = 'MEDIUM',
    XMEDIUM = 'XMEDIUM',
    LARGE = 'LARGE',
    BIG = 'BIG',
    XBIG = 'XBIG',
    XXBIG = 'XXBIG'
  }
  
  export const ICON_DIMENSION = {
    [IconSize.XXBIG]: 220,
    [IconSize.XBIG]: 100,
    [IconSize.BIG]: 80,
    [IconSize.LARGE]: 60,
    [IconSize.XMEDIUM]: 48,
    [IconSize.MEDIUM]: 36,
    [IconSize.REGULAR]: 30,
    [IconSize.XREGULAR]: 26,
    [IconSize.SMALL]: 24,
    [IconSize.MSMALL]: 20,
    [IconSize.XSMALL]: 18,
    [IconSize.XXSMALL]: 12
  };
  